export const separeteNumber = (num) => {
    if(num){
        let numString = num.toString(); 
        const reverseNum = numString.split("").reverse().join("");
        const splitedNum = reverseNum.match(/.{1,3}/g).join(" ");
        return splitedNum.split("").reverse().join("")
    }

    return ""
}